import { api } from '@/api/client';

// Interface for merchant data
export interface Merchant {
  uuid: string;
  name: string;
  email: string;
  mobile_number?: string;
  is_active?: boolean;
  merchant_config?: Record<string, unknown> | null;
  key?: string | null;
  salt?: string | null;
  is_submerchant?: boolean;
  is_gateway_active?: boolean;
  submerchant_id?: string | null;
  kyc_status?: boolean | null;
}

// Interface for merchants API response
export interface MerchantsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Merchant[];
}

// Interface for login-as response
export interface LoginAsResponse {
  success: boolean;
  message?: string;
  token?: string;
  redirect_url?: string;
  user?: {
    id?: string;
    email?: string;
    name?: string;
    role?: string;
    [key: string]: unknown;
  };
}

// Interface for KYC response
export interface MerchantKycResponse {
  basic_details?: {
    name?: string;
    email?: string;
    phone?: string;
  };
  business_details?: {
    company_name?: string;
    entity_type?: string;
    address?: string;
  };
  bank_details?: {
    bank_name?: string;
    account_number?: string;
    ifsc?: string;
  };
  status?: string;
}


// Merchants service
export const merchantsService = {
  // Get list of merchants
  async getMerchants(
    page: number = 1,
    pageSize: number = 15,
    searchTerm?: string,
    name?: string,
    email?: string
  ): Promise<MerchantsResponse> {
    const params: Record<string, string | number> = {
      page,
      page_size: pageSize,
    };

    // If separate name/email filters are provided, use them; otherwise fall back to search
    if (name || email) {
      if (name) params.name = name;
      if (email) params.email = email;
    } else if (searchTerm) {
      params.search = searchTerm;
    }

    const response = await api.get<MerchantsResponse>('/backoffice/api/v1/merchants/', {
      params,
    });
    return response as unknown as MerchantsResponse;
  },

  // Login as merchant
  async loginAs(uuid: string): Promise<LoginAsResponse> {
  const response = await api.post<LoginAsResponse>(
    `/backoffice/api/v1/merchants/login-as/${uuid}/`
  );
  return response;
},


// Get Merchant KYC
  getMerchantKyc: async (merchant_uuid: string) => {
  return api.post("/backoffice/api/v1/merchant/kyc/", {
    merchant_uuid
  });
},

// Update KYC Status
  updateKycStatus: async (payload: { kyc_type: string; uuid: string; kyc_status: number; reason: string }) => {
    return api.post('/backoffice/api/v1/merchant/kyc-status/', payload);
  }


};
